import React from 'react'
import './Videos.css'

function Videos() {
    return (
        <div class='videos'>
            <h1>Videos</h1>
             <h5>Coming soon</h5>
        </div>
    )
}

export default Videos
